module.exports = __webpack_public_path__ + "img/img_16.ae4a6936.jpg";